import {AppBar, Box, Button, Dialog, IconButton, Slide, Toolbar, Typography} from "@mui/material";
import moment from "moment-jalaali";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import { ReactComponent as ThreeDotsIcon } from "../Assets/svg/ThreeDotsIcon.svg";
import { ReactComponent as PhoneIcon } from "../Assets/svg/PhoneIcon.svg";
import { ReactComponent as GrayLocation } from "../Assets/svg/GrayLocation.svg";
import { ReactComponent as CloseIcon } from "../Assets/svg/CloseIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as ShareIcon2 } from "../Assets/svg/ShareIcon2.svg";

import DemandContactModal from "./DemandContactModal";
import http from "../api/axiosInstance";
import Cookies from "js-cookie";
import ModalComponent from "./ModalComponent";
import {useUserStore} from "../store/user";
import jalaliMoment from "jalali-moment";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function PropertyAdaptItem(props){

    const { applicant, propertyId } = props
    const navigate = useNavigate();

    const [openMoreOptionsModal, setOpenMoreOptionsModal] = useState(false)
    const [contactModal, setContactModal] = useState(false);
    const [adaptPercent, setAdaptPercent] = useState(false);
    const [percentAdaptValue, setPercentAdaptValue] = useState(applicant.AdaptPercent);
    const accessToken = useUserStore((state) => state.accessToken)

    const handleSendDemandInfo = async () => {

        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i)) {

            let property = {};

            try {
                const data = await http({
                    url: `properties/get/list/by/filter`,
                    method: "POST",
                    data: {
                        LocationId: applicant.LocationId,
                        LandLordInfo: true,
                        AgencyInfo: true,
                        Ids: [propertyId]
                    },
                    headers: {
                        "Authorization": `Bearer ${Cookies.get('token')}`
                    }
                })

                if(data && data.data && data.data.result && data.data.result.Properties.length > 0){
                    property = data.data.result.Properties[0];
                }
                else{
                    console.log(data)
                    alert("خطایی رخ داد")
                    return;
                }

            }
            catch (e){
                console.log(e)
                alert("خطایی رخ داد")
                return;
            }

            let message = `${property.PropertyType} ${property.PropertyArea ? 'واقع در ' + property.PropertyArea : ''} 
به قیمت ${
                (property.ForSale && property.SalePrice.toLocaleString()) +
                (property.ForRent && (property.MortgagePrice1.toLocaleString() + " رهن و " + property.RentPrice1.toLocaleString() + " اجاره") )
            } 
متراژ ${property.Infrastructure ? property.Infrastructure : property.Space} متر 
طبقه ${property.StoreyNo == 0 ? "همکف" : property.StoreyNo} 
تعداد اتاق ${property.RoomsCount}
 ${property?.Agency.AgencyName}
تلفن : ${property?.Agency.AgencyMobile}
آدرس : ${property?.PhysicalAddress}`

            message = encodeURIComponent(message.trim())
            window.location.href = `sms://+98${applicant.Mobile.substring(1)}?body=${message}ppp`;

        }
        else{
            alert("در این مرورگر امکان ارسال وجود ندارد")
        }

    }

    const handleSetAdaptPercent = async (e) => {

        const data= {
            AdaptPercent: e.target.value,
            PropertyId: propertyId,
            ApplicantId: applicant.Id
        };

        if (!e.target.checked) {
            data["AdaptPercent"] = ""
        }

        try {
            const res = await http({
                url: `/applicants/adapts/update`,
                method: "POST",
                data: data,
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            })

            if (res.data.result) {
                setPercentAdaptValue(data["AdaptPercent"])
                setAdaptPercent(false)

            }
            else{
                console.error(res);
            }

        }
        catch (e) {
            console.error(e);
        }

    }

    return (
        <>
            <Box className={`dash-property-item ${applicant.IsBought ? "IsBought" : ""}`} onClick={() => navigate(`/applicant/${applicant.Id}`)}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px', mb: 1 }}>
                    <Box>
                        <Box sx={{ color: '#000000' }}>
                            {(applicant.RequestSale == 1 || applicant.RequestPreSale == 1) && "خرید "}
                            {applicant.RequestRent == 1 && "اجاره "}
                            {applicant.RequestExchange == 1 && "معاوضه "}
                            {applicant.RequestAssociate == 1 && "مشارکت "}
                            {applicant.PropertyTypes && applicant.PropertyTypes[0] && ` | ${applicant.PropertyTypes[0]}`}
                            {applicant.PropertyTypes && applicant.PropertyTypes[1] && ` | ${applicant.PropertyTypes[1]}`}
                            {applicant.PropertyTypes && applicant.PropertyTypes[2] && ` | ${applicant.PropertyTypes[2]}`}
                        </Box>
                    </Box>
                    <Box>
                        <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', gap: '10px' }}>
                            <Box>{applicant.Row}</Box>
                            <IconButton onClick={e => {
                                e.stopPropagation()
                                setOpenMoreOptionsModal(true);
                            }}>
                                <ThreeDotsIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex' }}>
                    <Box sx={{ flex: '1' }}>
                        {applicant.RequestSale == 1 ? <Box sx={{ fontSize: '13px', mt: 1 }}>قیمت از {applicant.MinSalePrice.toLocaleString()} تا {applicant.MaxSalePrice.toLocaleString()}</Box> : null}
                        {applicant.RequestRent == 1 ? <Box sx={{ fontSize: '13px', mt: 1 }}>قیمت اجاره از {applicant.MinRentPrice.toLocaleString()} تا {applicant.MaxRentPrice.toLocaleString()}</Box> : null}
                        {applicant.RequestRent == 1 ? <Box sx={{ fontSize: '13px', mt: 1 }}>قیمت رهن از {applicant.MinMortgagePrice.toLocaleString()} تا {applicant.MaxMortgagePrice.toLocaleString()}</Box> : null}
                    </Box>
                </Box>
                {applicant.Areas && applicant.Areas.length ?
                    <Box sx={{ display: 'flex', gap: '5px', fontSize: '13px', mt: 1 }}>
                        <GrayLocation />
                        <Box>
                            {applicant.Areas.toString()}
                            {/* {applicant.Areas && applicant.Areas.length ? applicant.Areas.map((item,index) => {
                        return <Typography component="span" key={index}>{item}</Typography>
                    }) : "-"} */}
                        </Box>
                    </Box>
                    : ""
                }
                <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '20px', fontSize: '13px', mt: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Box>زیربنا از {applicant.MinInfrastructure && applicant.MinInfrastructure} تا {applicant.MaxInfrastructure && applicant.MaxInfrastructure} متر</Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px' }}>
                        <Box>مساحت از {applicant.MinSpace && applicant.MinSpace} تا {applicant.MaxSpace && applicant.MaxSpace} متر</Box>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', fontSize: '13px', mt: 2 }}>
                    <Button onClick={(e) => {
                        e.stopPropagation()
                        setAdaptPercent(true);
                    }} sx={{ bgcolor: '#D6ECD2!important', fontSize: "12px", color: "#707070", borderRadius: "25px", display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}>
                        {percentAdaptValue == "" ? 'تعیین درصد انطباق' :
                            percentAdaptValue == "<50" ? "کمتر از 50 درصد" :
                                percentAdaptValue == "50-80" ? "بین 50 تا 80 درصد" :
                                    percentAdaptValue == ">80" ? "بیشتر از 80 درصد" : "تعیین درصد انطباق"
                        }
                        <ArrowRightIcon className="rotate-90" />
                    </Button>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px' }}>
                        <IconButton sx={{ bgcolor: '#D6ECD2!important' }} onClick={e => {
                            e.stopPropagation()
                            setContactModal(true);
                        }}>
                            <PhoneIcon />
                        </IconButton>
                        <Box>
                            {/*{moment.unix(applicant.RegisterDate).format("jYYYY/jMM/jDD")}*/}
                            {jalaliMoment(new Date(applicant.RegisterDate * 1000)).locale('fa').fromNow()}
                            {applicant.ExpireDate && applicant.ExpireDate < parseInt(+(new Date()) / 1000) ? " (منقضی شده)" : ""}
                        </Box>
                    </Box>

                </Box>
            </Box>

            {openMoreOptionsModal && <Dialog
                className="dialog-box"
                fullScreen
                open={openMoreOptionsModal}
                onClose={() => {setOpenMoreOptionsModal(false)}}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>
                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب کنید */}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => {setOpenMoreOptionsModal(false)}}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>

                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px', px: 4 }}>
                    <Box>
                        می توانید برای این متقاضی مشخصات ملک مورد نظر را از
                        طریق پیامک و یا اپلیکیشن های پیام رسانی
                        ارسال کنید
                    </Box>
                    <Button className="green-outline-btn" onClick={handleSendDemandInfo} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <ShareIcon2 />
                            <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>ارسال</Box>
                        </Box>
                        <ArrowRightIcon className="rotate-180-minus" />
                    </Button>
                </Box>
            </Dialog>}

            {contactModal && <DemandContactModal ContactModal={contactModal} handleContactModalClose={() => {setContactModal(false)}} propInfo={applicant} />}

            {adaptPercent && <ModalComponent
                showModalState={adaptPercent}
                handleModalClose={() => setAdaptPercent(false)}
                modalTitle=""
                disableSubmitBtn={true}
            >
                <Box sx={{ mt: 3, px: 2, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '5px', paddingBottom: '70px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <input type="checkbox" id='percentAdapt1' className="d-none typeCheck" name="percentAdapt" value="<50" checked={percentAdaptValue == "<50"} onChange={e => handleSetAdaptPercent(e)} />
                        <label htmlFor='percentAdapt1' className='typeLabel w-100 d-flex justify-content-around'>
                            <div>کمتر از 50 درصد</div>
                        </label>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <input type="checkbox" id='percentAdapt2' className="d-none typeCheck" name="percentAdapt" value="50-80" checked={percentAdaptValue == "50-80"} onChange={e => handleSetAdaptPercent(e)} />
                        <label htmlFor='percentAdapt2' className='typeLabel w-100 d-flex justify-content-around'>
                            <div>بین 50 تا 80 درصد</div>
                        </label>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <input type="checkbox" id='percentAdapt3' className="d-none typeCheck" name="percentAdapt" value=">80" checked={percentAdaptValue == ">80"} onChange={e => handleSetAdaptPercent(e)} />
                        <label htmlFor='percentAdapt3' className='typeLabel w-100 d-flex justify-content-around'>
                            <div>80 درصد به بالا</div>
                        </label>
                    </Box>

                </Box>
            </ModalComponent>}
        </>
    )
}